var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear",
    clipPath: "url(#clip0_1302_2614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6741 4.81878L11.7336 3.75879L8.00479 7.96116L4.27599 3.75879L3.33545 4.81878L7.06425 9.02115L3.33545 13.2235L4.27599 14.2835L8.00479 10.0811L11.7336 14.2835L12.6741 13.2235L8.94532 9.02115L12.6741 4.81878Z",
    fill: "#1F3859"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_2614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0092,
    height: 18.0424,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.eb9a29ab7be0c28109e56684c202b86d.svg";
export { ForwardRef as ReactComponent };